import React from 'react';
import './index.css';
import PokedexFilters from './PokedexFilters';
import PokedexTableCard from './PokedexTableCard';
import PokedexSpriteCard from './PokedexSpriteCard';
import PokedexBaseStats from './PokedexBaseStatsCard';
import PokedexFlavorTextCard from './PokedexFlavorTextCard';

function App() {
  return (
    <div className="container">
      <div className="flex flex-row py-6">
        <div className="sticky top-0 p-2 w-full sm:w-1/5 md:w-1/6 px-2">
          <PokedexFilters />
        </div>
        <div className="w-full sm:w-3/5 md-3/6 pt-1 px-2">
          <PokedexTableCard />
        </div>
        <div className="sticky overflow-auto top-0 w-full sm:w-1/5 md-2/6 pt-1 px-2">
          <div className="text-center">
            <PokedexSpriteCard />
          </div>
          <div className="block my-2">
            <PokedexFlavorTextCard />
          </div>
          <div className="block my-2">
            <PokedexBaseStats />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
